import React from 'react';
import mainImg from "../dashboard.png";

const Hero = ({ isPopupOpen = false, openPopup }) => {
  return (
    <section id="hero" className="pt-32 pb-20 bg-gradient-to-br from-[#fdf6ff] via-[#f7f3ff] to-[#fdf6ff] relative overflow-hidden">
            {/* Floating background shapes */}
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-gradient-to-tr from-[#3e2ef433] to-[#3e2ef433] blur-3xl animate-float"></div>
      <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] rounded-full bg-gradient-to-tr from-[#ff009533] to-[#ff009533] blur-3xl animate-float"></div>

      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-hector-blue rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-hector-purple rounded-full filter blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-[55px] lg:text-6xl font-bold text-hector-black leading-tight text-center md:text-left leading-[55px] md:leading-[1.5]">
                Cash In On Your <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">Amazon Connections Now</span>
              </h1>
              <p className="text-xl text-hector-dark-grey leading-relaxed text-center md:text-left">
                Transform your Amazon expertise into revenue. Refer brands to Hector AI and get rewarded for every sale starting today.
              </p>
              <p className="text-lg text-gray-600 font-medium text-center md:text-left">
                You've built your reputation in the Amazon ecosystem. Now monetise it.
              </p>
            </div>
            
            <div className="space-y-4">
<a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <button 
    className="cta-button px-8 py-4 rounded-xl font-semibold text-white text-base md:text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    JOIN THE HECTOR AFFILIATE NETWORK
  </button>
</a>


              <p className="text-sm text-gray-600 text-center md:text-left">
                <span className="font-semibold text-hector-blue">Get Started Free</span> | <span className="font-semibold text-hector-purple">See Commission Structure</span>
              </p>
            </div>
            
            {/* Trust Badges */}
            <div className="grid grid-cols-2 gap-6 pt-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-hector-blue to-cyan-400 rounded-xl flex items-center justify-center">
                  <i className="fas fa-chart-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-hector-black">$200M+</div>
                  <div className="text-sm text-gray-600">Ad Spend Managed</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-hector-purple to-pink-400 rounded-xl flex items-center justify-center">
                  <i className="fas fa-star text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-hector-black">98%+</div>
                  <div className="text-sm text-gray-600">Program Satisfaction</div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Dashboard Mockup */}
          <div className="relative">
          <div className="p-6">
  <img
    src={mainImg}
    alt="Dashboard Preview"
    className="w-full h-auto rounded-xl object-cover animate-float"
  />
</div>

            
            {/* Floating Elements */}


        
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
